<template>
  <div class="container">
    <span class="title">{{ titleOne }}</span>
    <TableOne
      :ingresoContrata="ingresoContrata"
      :porcentajeIngreso="porcentajeIngreso"
      :readOnly="readOnly"
    />
    <span class="title">{{ titleTwo }}</span>
    <TableTwo
      :procesoRegularizacion="procesoRegularizacion"
      :ingresoContrata="ingresoContrata"
      :honorariosRegularizado="honorariosRegularizado"
    />
    <span class="title">{{ titleThree }}</span>
    <TableThree
      :honorariosRegularizado="honorariosRegularizado"
      :readOnly="readOnly"
    />
  </div>
</template>

<script>
// import Table from "./components/Table.vue";
import TableOne from "./components/mainTableNine/TableOne";
import TableTwo from "./components/mainTableNine/TableTwo.vue";
import TableThree from "./components/mainTableNine/TableThree";
export default {
  props: [
    "ingresoContrata",
    "procesoRegularizacion",
    "honorariosRegularizado",
    "porcentajeIngreso",
    "readOnly",
  ],
  components: {
    // Table,
    TableOne,
    TableTwo,
    TableThree,
  },
  data() {
    return {
      //Primary Table
      titleOne: "9.1 Representación en el ingreso a la Contrata",
      encabezado: "Variables",
      textOne:
        "(a) N° de personas a honorarios traspasadas a la contrata año t",
      textTwo: "(b) Total de ingresos a la contrata año t",
      textThree: "Porcentaje de honorarios traspasados a la contrata (a/b)",
      inputFour: "",
      inputOne: "",
      inputTwo: "",
      inputThree: "",
      inputFive: "",
      inputSix: "",

      //Second Table
      titleTwo: "9.2 Efectividad proceso regularización",
      textTwoOne:
        "(a) N° de personas a honorarios traspasadas a la contrata año t",
      textTwoTwo: "(b) N° de personas a honorarios regularizables año t-1",
      textTwoThree: "Porcentaje de honorarios regularizados (a/b)",
      inputTwoOne: "",
      inputTwoTwo: "",
      inputTwoThree: "",
      inputTwoFive: "",
      inputTwoSix: "",

      //Third Table
      titleThree: "9.3 Índice honorarios regularizables",
      textThreeOne: "(a) N° de personas a honorarios regularizables año t",
      textThreeTwo: "(b) N° de personas a honorarios regularizables año t-1",
      textThreeThree: "PoPorcentaje (a/b)",
      inputThreeOne: "",
      inputThreeTwo: "",
      inputThreeThree: "",
      inputThreeFive: "",
      inputThreeSix: "",
    };
  },
};
</script>

<style scoped>
.title {
  color: #052333;
  font-size: 17px;
  font-weight: bold;
  margin-top: 10px !important;
  margin-bottom: 10px;
}
</style>
